<template>
  <v-toolbar color="#3273b3" height="70px">
    <v-btn
      class="ml-1"
      fab
      v-b-tooltip.hover
      title="Click To Add"
      color="#2722a6"
      v-b-modal.time-sheet-add-modal
    >
      <v-icon large color="white">mdi-plus</v-icon>
    </v-btn>
    <v-menu v-model="menu" :close-on-content-click="false" offset-y tile>
      <template v-slot:activator="{on, attrs}">
        <v-btn
          class="ml-6 white--text"
          fab
          color="#2722a6"
          v-b-tooltip.hover
          title="Click to Filter"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="white"> mdi-filter</v-icon>
        </v-btn>
      </template>
      <v-card color="whitesmoke" width="400px">
        <v-card-title> Filter </v-card-title>
        <v-form @submit="onApply">
          <v-container>
            <v-row class="mx-2">
              <v-autocomplete
                clearable
                label="Projects"
                outlined
                item-text="text"
                item-value="value"
                :items="projects"
                v-model="filterForm.projects"
              ></v-autocomplete> </v-row
            ><v-row class="mx-2">
              <v-autocomplete
                clearable
                label="Members"
                outlined
                item-text="text"
                item-value="value"
                :items="teams"
                v-model="filterForm.teams"
              ></v-autocomplete>
            </v-row>
            <v-row class="mx-2 mb-1">
              <v-btn small outlined color="primary" @click="setAllTimeRange">
                All time
              </v-btn>
              <v-btn
                small
                outlined
                color="primary"
                class="ml-2"
                @click="setCurrentMonthDateRange"
              >
                This month
              </v-btn>
            </v-row>
            <v-row>
              <v-col>
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{on}">
                    <v-text-field
                      outlined
                      v-model="filterForm.start_date"
                      label="from"
                      prepend-icon="mdi-calendar"
                      clearable
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filterForm.start_date"
                    @change="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="200px"
                >
                  <template v-slot:activator="{on}">
                    <v-text-field
                      outlined
                      v-model="filterForm.end_date"
                      label="to"
                      prepend-icon="mdi-calendar"
                      clearable
                      readonly
                      v-on="on"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filterForm.end_date"
                    @change="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            color="green darken-1"
            text
            type="submit"
            @click="onApply"
          >
            Apply
          </v-btn>
          <v-btn tile color="green darken-1" text @click="menu = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </v-toolbar>
</template>

<script>
export default {
  name: "TimeSheetToolBar",
  props: ["projects", "teams"],
  data() {
    return {
      filterForm: {
        projects: null,
        teams: null,
        start_date: "",
        end_date: "",
      },
      menu1: false,
      menu2: false,
      menu: false,
    };
  },
  mounted() {
    this.setCurrentMonthDateRange();
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    setCurrentMonthDateRange() {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.filterForm.start_date = this.formatDate(firstDay);
      this.filterForm.end_date = this.formatDate(lastDay);
    },
    setAllTimeRange() {
      this.filterForm.start_date = "";
      this.filterForm.end_date = "";
    },
    applyFilter() {
      this.$emit("filter-value", {...this.filterForm});
      this.menu = false;
    },
    onApply(evt) {
      evt.preventDefault();
      this.applyFilter();
    },
  },
};
</script>

<style scoped></style>
